import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import SizeSelectorContent from './SizeSelectorContent';
import { useBellaSelector } from 'Client/redux/hooks';
import { setSizeSelectorIsOpen } from 'Client/redux/productdetail/actions';
import { BellaTestIds } from 'Common/qaIds';
import useRouter from 'Client/hooks/useRouter';

const BackDrop = styled.div<{ isOpen?: boolean }>`
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    width: 100%;
    height: 100vh;
    position: fixed;
    background: ${({ theme }) => theme.colors.skeleton02};
    z-index: ${({ theme }) => theme.zIndexPopUpOverlay};
    right: 0;
`;

const Wrapper = styled.div<{ isOpen?: boolean }>`
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
`;

const CustomSizeSelectorOverlay: React.FC = () => {
    const dispatch = useDispatch();
    const {
        location: { pathname, search },
    } = useRouter();
    const isOpen = useBellaSelector(state => state.productdetails.sizeSelectorIsOpen);

    const dismissFunction = () => {
        dispatch(setSizeSelectorIsOpen(false));
    };

    useEffect(() => {
        dismissFunction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, search]);

    return (
        <Wrapper isOpen={isOpen} data-testid={BellaTestIds.pdpSizeSelectorOverlay}>
            <BackDrop isOpen={isOpen} onClick={dismissFunction} />
            <SizeSelectorContent isOpen={isOpen} dismissFunction={dismissFunction} />
        </Wrapper>
    );
};

export default CustomSizeSelectorOverlay;
